import { render, staticRenderFns } from "./LeadReview.vue?vue&type=template&id=a07d0cf8&scoped=true&"
import script from "./LeadReview.vue?vue&type=script&lang=js&"
export * from "./LeadReview.vue?vue&type=script&lang=js&"
import style0 from "./LeadReview.vue?vue&type=style&index=0&id=a07d0cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07d0cf8",
  null
  
)

export default component.exports